<template>
  <div
    class="empty"
    :style="customStyles"
  >
    <base-text
      medium
      class="title"
      size="l"
    >
      {{ title }}
    </base-text>
    <base-text
      size="m"
      light
      class="message"
    >
      <slot>{{ subtitle }}</slot>
    </base-text>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    align: {
      type: [String, Number],
      required: false,
      default: 'center', // Top, Center, Number
    },
    minHeight: {
      type: String,
      required: false,
      default: '130px',
    },
  },
  computed: {
    position() {
      if (this.align === 'center') {
        return {
          'justify-content': 'center',
        };
      }

      if (this.align === 'top') {
        return {
          'justify-content': 'start',
          'padding-top': '62px',
        };
      }

      const padding = (typeof this.align === 'string') ? this.align : `${this.align}px`;

      return {
        'padding-top': padding,
      };
    },
    customStyles() {
      return {
        ...this.position,
        'min-height': this.minHeight,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.empty {
  background-color: $gray-light;
  text-align: center;
  color: $gray;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow:1;
  flex-shrink: 0;

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 5px;
  }
  .message {
    line-height: 16px;
  }
}

</style>
